<template>
  <v-container grid-list-md class="pa-5">
    <m-breadcrum :items="bread"></m-breadcrum>
    <v-row>
      <v-col cols="12">
        <m-card title="Detail Grup Kelas">
          <div class="mx-2">
            <v-row no-gutters class="body-1">
              <v-col cols="12" sm="12" md="3" lg="3">Nama</v-col>
              <v-col cols="12" sm="12" md="3" lg="3" class="primary--text">: {{ grup.nama }}</v-col>
              <v-col cols="12" sm="12" md="3" lg="3">Zona Waktu Acuan</v-col>
              <v-col cols="12" sm="12" md="3" lg="3" class="primary--text">: {{ grup.zona_waktu }}</v-col>
              <v-col cols="12" sm="12" md="3" lg="3">Kode</v-col>
              <v-col cols="12" sm="12" md="3" lg="3" class="primary--text">: {{ grup.kode }}</v-col>
              <v-col cols="12" sm="12" md="3" lg="3">Jumlah Peserta</v-col>
              <v-col cols="12" sm="12" md="3" lg="3" class="primary--text">: {{ grup.jumlah_peserta }}</v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="grup.kelas"
                  hide-default-footer
                  :items-per-page="15"
                  item-key="id"
                >
                  <template v-slot:body="{ items }">
                    <th class="text-left py-4 body-1">Daftar Kelas</th>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <v-row class="mx-3 py-3" no-gutters>
                          <v-col cols="3" sm="2" md="1" lg="1" align="center">
                            <v-avatar width="50" height="50" :size="45" color="secondary2">
                              <v-icon color="secondary">mdi-google-classroom</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="12" sm="10" md="11" lg="11">
                            <v-row>
                              <v-col class="py-0" cols="12" md="4" sm="4">
                                <p class="caption my-0 py-0 grey--text align-left">Nama Kelas</p>
                                <router-link
                                  class="primary--text title"
                                  :to="{
                                    name: 'kelas.detail',
                                    params: {
                                      instansi_id: item.instansi_id,
                                      diklat_id: item.diklat_id,
                                      kelas_id: item.id
                                    }
                                  }"
                                  >{{ pVal(item, "nama") }}</router-link
                                >
                              </v-col>

                              <v-col class="py-0" cols="12" md="2" sm="2">
                                <p class="caption my-0 py-0 grey--text">Jumlah Peserta</p>
                                <span class="my-0 py-0"
                                  ><pre>{{ item.peserta_count }}</pre>
                                </span>
                              </v-col>
                              <v-col class="py-0" cols="12" md="4" sm="4">
                                <p class="my-0 caption grey--text">Jadwal Kelas</p>
                                <span class="my-0 py-0"
                                  >{{ pVal(item, "tanggal_mulai") | toDT }} s/d
                                  {{ pVal(item, "tanggal_selesai") | toDT }}</span
                                >
                              </v-col>
                              <v-col class="py-0" cols="12" md="2" sm="2">
                                <p class="caption my-0 py-0 grey--text">Zona Waktu Acuan</p>
                                <span class="my-0 py-0">{{ item.zona_waktu }} </span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </m-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListTable from "../../enroll/components/ListTable.vue";
import ListGroup from "../../kelas/components/ListGroup.vue";
import ChangeDlg from "../../enroll/components/Form.vue";
import ChangeGroupingDlg from "../../kelas/components/FormGrouping.vue";
export default {
  components: {
    ListTable,
    ListGroup,
    ChangeDlg,
    ChangeGroupingDlg
  },
  data() {
    return {
      grup: {},
      items: [],
      page: null,
      cp: 1
    };
  },
  mounted() {
    this.detail();
  },
  methods: {
    detail() {
      return this.$store
        .dispatch("kelas/detailGrupKelas", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          grup_id: this.$route.params.grup_id
        })
        .then(res => {
          this.grup = res;
        })
        .catch(e => e);
    }
  },
  watch: {
    grup_id() {
      this.detail();
    }
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "", sortable: false },
        { text: "", align: "left", value: "", sortable: false },
        { text: "", align: "left", value: "", sortable: false }
      ];
      return a;
    },
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Grup Kelas",
          to: {
            name: "groupKelas",
            params: { instansi_id: this.instansi_id, diklat_id: this.diklat_id, grup_id: this.grup_id }
          }
        },
        {
          icon: "mdi-edit",
          title: this.grup ? this.grup.nama : "-"
        }
      ];
    },
    kelasmodul() {
      return this.$store.getters["kelas/grouping"];
    }
  }
};
</script>
